<template>
  <div class="profile-page" data-test="profile__page">
    <PageHeader :title="pageTitle"/>
    <div style="margin-top: 20px;"></div>

    <PageContainer size="small">
      <div style="margin-top: 40px;"></div>
      <UserProfileJumbo
        v-loading="loading"
        :profile="profile"
        :passwordEditable="isOwnProfile"
        :profileEditable="!isOwnProfile"
        :roleEditable="!isOwnProfile"
        :titleEditable="!isOwnProfile"
        :deletable="!isOwnProfile"
        @profileUpdated="handleProfileChange"
      />
    </PageContainer>
  </div>
</template>
<script>
import PageHeader from '@/components/PageHeader/PageHeader.vue';
import PageContainer from '@/components/PageContainer/PageContainer.vue';
import UserProfileJumbo from '@/views/pages/ProfilePage/UserProfileJumbo.vue';
import UserProfile from '@/entities/UserProfile';
import services from 'services';

export default {
  components: {
    PageHeader,
    PageContainer,
    UserProfileJumbo,
  },
  props: {
    userId: { type: String, required: false },
    pageTitle: { type: String, required: true },
  },
  mounted() {
    this.remount();
  },
  data() {
    return {
      loading: false,
      profile: null,
    };
  },
  watch: {
    userId() {
      this.remount();
    },
  },
  computed: {
    isOwnProfile() {
      return !this.userId || this.userId === this.$store.getters['auth/currentUserId'];
    },
  },
  methods: {
    async remount() {
      this.loading = true;
      await this.fetchData();
      this.loading = false;
    },
    async fetchData() {
      if (!this.userId) {
        await this.$store.dispatch('auth/fetchCurrentUserProfile');
        this.profile = this.$store.getters['auth/currentUserProfile'];
        return this.profile;
      }
      return this.fetchUserProfile(this.userId);
    },
    async fetchUserProfile(userId) {
      const profile = await services.userService.getUser(userId);
      this.profile = profile;
    },
    handleProfileChange(newProfile) {
      this.profile = new UserProfile(newProfile);
    },
  },
};
</script>
<style lang="stylus" scoped>
.profile-page {
  width: 100%;
}
</style>
